import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import isEqual from 'lodash/isEqual';
import { mapState } from 'vuex';
import CoreSplitButton from '@/components/core/splitButton.vue';
export default {
  name: 'CoreAccountFilter',
  components: {
    CoreSplitButton: CoreSplitButton
  },
  props: {
    // The default list of account ids of the filter
    default: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    // Set specific accounts to be selected, but do not return to these when resetting
    selected: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    // If true, the component will allow multiple accounts to be selected
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    // If true, the component will allow the selected accounts to be empty
    allowEmpty: {
      type: Boolean,
      required: false,
      default: false
    },
    // If true, the component will use the niota 1.0 API to fetch account data
    n1Accounts: {
      type: Boolean,
      required: false,
      default: false
    },
    // If true, the trigger button will contain the icon only with no text label
    iconOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    // If true, the reset button will be hidden
    hideReset: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      accounts: [],
      isLoading: false,
      searchInput: null,
      selectedAccountIds: [],
      dynamicKey: 'key'
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])), {}, {
    /**
     * Is true if selectedAccountIds array has one or more entries, otherwise false.
     */
    hasSelection: function hasSelection() {
      return this.selectedAccountIds.length > 0;
    },

    /**
     * Is true while props iconOnly and hideReset are both true, otherwise false.
     */
    isSingleButton: function isSingleButton() {
      return this.iconOnly && this.hideReset;
    },

    /**
     * A filtered version of searchResults array, which does not contain any selected accounts.
     */
    searchResultsWithoutSelected: function searchResultsWithoutSelected() {
      var _this = this;

      return this.searchResults.filter(function (item) {
        return !_this.selectedAccountIds.includes(item.id);
      });
    },

    /**
     * A filtered version of the accounts array, which only contains selected accounts.
     */
    selectedAccounts: function selectedAccounts() {
      var _this2 = this;

      return this.accounts.filter(function (item) {
        return _this2.selectedAccountIds.includes(item.id);
      });
    },

    /**
     * A filtered version of the accounts array, which only contains accounts which match the search input.
     * If no search input is given, the full accounts array is returned.
     */
    searchResults: function searchResults() {
      var _this3 = this;

      if (this.searchInput) {
        return this.accounts.filter(function (item) {
          return _this3.searchInput.toLowerCase().split(' ').every(function (v) {
            return item.name.toLowerCase().includes(v) || item.id === parseInt(v, 10);
          });
        });
      } else {
        return this.accounts;
      }
    }
  }),
  watch: {
    selected: {
      handler: function handler(accounts) {
        this.selectedAccountIds = this.sanitizeSelectedIds(accounts);
        this.storeAndEmitSelection();
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.fetchAccounts();
  },
  methods: {
    /**
     * Makes sure the selectedIds are present in the current accounts array, filters out invalid ids.
     * Also makes sure to only keep a single id if multiple prop is false.
     * @param {number[]} selectedIds
     * @returns {number[]}
     */
    sanitizeSelectedIds: function sanitizeSelectedIds(selectedIds) {
      var filtered = this.accounts.filter(function (item) {
        return selectedIds.includes(item.id);
      }).map(function (item) {
        return item.id;
      });
      return this.multiple ? filtered : [filtered.pop()];
    },

    /**
     * Take the given array of account ids and return the corresponding account objects
     * @param {number[]} ids
     * @returns {number[]}
     */
    getAccountsFromIds: function getAccountsFromIds(ids) {
      return this.accounts.filter(function (item) {
        return ids.includes(item.id);
      });
    },

    /**
     * Commit selectedAccountIds to VueX store and emit 'change' event with the according account objects
     * @returns {void}
     */
    storeAndEmitSelection: function storeAndEmitSelection() {
      var mutationName = this.n1Accounts ? 'app/n1Accounts' : 'app/n2Accounts';
      this.$store.commit(mutationName, {
        selectedIds: this.selectedAccountIds
      });
      this.$emit('change', this.getAccountsFromIds(this.selectedAccountIds));
    },

    /**
     * Initialize account selection on mounted()
     * Use account ids from the store if available, otherwise use the default props list of ids
     * Emit and store the selection so the parent component can react to it
     */
    initializeSelection: function initializeSelection() {
      var selected = this.n1Accounts ? this.$store.state.app.n1Accounts.selectedIds : this.$store.state.app.n2Accounts.selectedIds;

      if (selected.length === 0) {
        selected = this.default;
      }

      this.selectedAccountIds = this.sanitizeSelectedIds(selected);
      this.storeAndEmitSelection();
      this.$emit('ready');
    },

    /**
     * Called whenever the menu closes or opens and resets the search input to null on close
     * @param {Boolean} isOpen
     * @returns {void}
     */
    handleDropdownChange: function handleDropdownChange(isOpen) {
      // reset search input when dropdown is closed
      if (!isOpen) {
        this.searchInput = null;
      }
    },

    /**
     * Handling clicks on list items in the dropdown menu.
     * Providing deselect as true will remove the clicked item from current selection, otherwise it will be added.
     * If the new selection is empty and allowEmpty is false, the selection will be reset to the default value.
     * Stores and emits the new selection.
     *
     * @param {Number} accountId
     * @param {Boolean} [deselect=false]
     * @returns {void}
     */
    handleListItemClicked: function handleListItemClicked(accountId) {
      var deselect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.dynamicKey = Date.now();
      var newSelected;

      if (deselect) {
        newSelected = this.selectedAccountIds.filter(function (item) {
          return item !== accountId;
        });
      } else {
        newSelected = this.multiple ? [].concat(_toConsumableArray(this.selectedAccountIds), [accountId]) : [accountId];
      } // if selection is empty, and empty is not allowed, set selection to default again


      if (!this.allowEmpty && newSelected.length === 0) {
        this.handleResetClicked();
      } else {
        this.selectedAccountIds = newSelected;
        this.storeAndEmitSelection();
      }
    },

    /**
     * Reset the selection to the default value and store and emit the new selection
     * @returns {void}
     */
    handleResetClicked: function handleResetClicked() {
      this.searchInput = null;
      var selected = this.sanitizeSelectedIds(this.default);

      if (!isEqual(selected, this.selectedAccountIds)) {
        this.selectedAccountIds = selected;
        this.storeAndEmitSelection();
      }
    },

    /**
     * Fetch accounts from the API and store them in the accounts array. Also initialize the selection.
     * @returns {void}
     */
    fetchAccounts: function fetchAccounts() {
      var _this4 = this;

      this.isLoading = true;
      this.$store.dispatch('app/loadAccounts', {
        n1Accounts: this.n1Accounts
      }).then(function (accounts) {
        _this4.isLoading = false;
        _this4.accounts = accounts;

        _this4.$emit('accounts-loaded');

        _this4.initializeSelection();
      }).catch(function (error) {
        _this4.$snack(_this4.$i18n_t('Common.errorLoadingAccounts'), 'error');

        _this4.$emit('accounts-error');

        console.error(error);
      });
    }
  }
};